$(document).ready(function(){
  
  
  var firstprice = 20;
 // console.log("First Price"+firstprice);
  /*$(".info-cart-button").click(function(){
      
      var gettitle = $(this).siblings(".titlee").html();
  var getprice = $(this).siblings(".price").html();
    var getpricewithout = $(this).siblings(".without_price").html();
    var gettag = $(this).siblings(".info-tag").html();
    var gethandle =$(this).siblings(".handle").html();
      var htmll = "<div class='image-handle'><img src='"+$(this).siblings(".image_info").attr("src")+"'><div class='gethandle' style='display:none;'>"+gethandle+"</div></div>";
      console.log("Title: "+gettitle+"Price: "+getprice+"Tag: "+gettag+"Handle: "+gethandle);
  $(".leftboxsec").append(htmll);
      $(".leftboxsec .image_info").show();
      
   //$(this).siblings(".handle").clone().appendTo( ".leftboxsec" ); 
  $("<div class='added-products'> <div class='addproindex'>1</div><div class='addtitle'>"+gettitle+"</div><div class='addproprice' data-price='"+getpricewithout+"'>"+getprice+"</div><div class='addtag' data-tag='"+gettag+"'></div><div class='addhandle' style='display:none;'>"+gethandle+"</div><div class='cross-product'>x</div></div>").appendTo( ".rightboxsec .rightboxsecfirst" );
   var priceadd = 0;
    $(".addproprice").each(function(){
    priceadd = parseInt(priceadd) + parseInt($(this).data("price")); 
      console.log("priceadd=="+priceadd);
    })
    var tagprice = 0;
    $(".addtag").each(function(){
    tagprice = parseInt(tagprice) + parseInt($(this).data("tag")); 
      console.log("pricetag=="+tagprice);
    })
   var twoPlacedFloat = parseFloat(priceadd).toFixed(2)
    $(".subtotal-price").html(twoPlacedFloat);
      
      $(".complete-button").click(function(){
    var tagprice_total = tagprice;
 console.log("tweret123");
    if(tagprice < firstprice)
    {
      var minus_price = firstprice - tagprice;
      $(".tag-price-count").show();
      $(".remaining").html(minus_price);
      console.log("abcd");
    }
      if(tagprice == 0)
    {
      
      $(".tag-price-empty").show();
      
    }
      if(tagprice > firstprice)
    {
      
      console.log("abcd");
    }
      
    });
    
    
      $(".product-info-box").hide();
      
      
    })*/
  $(".info-cart-button").click(function(){
    
      
      var gettitle = $(this).siblings(".titlee").html();
  var getprice = $(this).siblings(".price").html();
    var getpricewithout = $(this).siblings(".without_price").html();
    var gettag = $(this).siblings(".info-tag").html();
    var gethandle =$(this).siblings(".handle").html();
    var option_value1 = $(this).siblings(".variants").children('select[data-option=option1]').val();
    var option_value2 = $(this).siblings(".variants").children('select[data-option=option2]').val();
    $(".product-info-box .custom-text").addClass("custom2");
    var getattribute =$("textarea.custom2").val();
    console.log("Get Attribute: "+getattribute);
    if(option_value1 == null)
    {
      var options_values = "";
      console.log("if option values conditioned");
    }
    else
    {
    var options_values = "<div class='variants_value'>"+option_value1+"/"+option_value2+"</div>";
    }
    if(getattribute == null)
    {
      var attribute_value = "";
      console.log("attribute value null");
    }
    else
    {
      var attribute_value = "<div class='attribute_value' style='display:none;'>"+getattribute+"</div>";
    }
    console.log("option values"+options_values);
    console.log("Attribute values"+attribute_value);
      //$(this).children("img").clone().appendTo( ".leftboxsec" );
  // $(this).parents(".product-section").children(".handle").clone().appendTo( ".leftboxsec" );
    var match = 0;
    $(".added-products .addhandle").each(function(){
    var match_handle = $(this).html();
      if(match_handle == gethandle)
      {
        var increqty = $(this).siblings(".addproindex").html();
        var nowqty = parseInt(increqty)+1;
        $(this).siblings(".addproindex").html(parseInt(increqty)+1);
        
        var getprice = $(this).siblings(".addproprice").data("price");
        var total_price = parseInt(getprice)*parseInt(nowqty);
        total_price = parseFloat(total_price).toFixed(2);
        $(this).siblings(".addproprice").children("span").html(total_price);
        $(this).siblings(".addproprice").attr("data-price",total_price);
        
        
        var gettag1 = $(this).siblings(".addtag").data("tag");
        var total_tag = parseInt(gettag1)*parseInt(nowqty);
        $(this).siblings(".addtag").attr("data-tag",total_tag);
        
       
        match =1;
        
        
        
      }
      
    })
    if(match == 1)
    {
      console.log("Matching");
    }
    if(match == 0)
    {
      console.log("NOt Matching");
      
    var htmll = "<div class='image-handle'><img src='"+$(this).siblings("img").attr("src")+"'><div class='gethandle' style='display:none;'>"+gethandle+"</div></div>";
    //  console.log("Title: "+gettitle+"Price: "+getprice+"Tag: "+gettag+"Handle: "+gethandle);
  $(".leftboxsec").append(htmll);
      //$(".leftboxsec .image_info").show();
      $(".fixed-tray").show();
      var html2 = "<div class='image-box-lower'><img src='"+$(this).siblings("img").attr("src")+"'><div class='gethandle' style='display:none;'>"+gethandle+"</div></div>";
    
  $(".custom-box-tray-items").append(html2);
      
      
   //$(this).siblings(".handle").clone().appendTo( ".leftboxsec" ); 
    $("<div class='added-products'> <div class='addproindex'>1</div><div class='addtitle'>"+gettitle+"</div><div class='addproprice' data-price='"+getpricewithout+"'>"+getprice+"</div><div class='addtag' data-tag='"+gettag+"'></div><div class='addhandle' style='display:none;'>"+gethandle+"</div><div class='cross-product'>x</div>"+options_values+attribute_value+"</div>").appendTo( ".rightboxsec .rightboxsecfirst" );
    }
    
    
    
    $(".complete-button").click(function(){
    var tagprice_total = tagprice;
 //console.log("tweret123");
    if(tagprice < firstprice)
    {
      var minus_price = firstprice - tagprice;
      $(".tag-price-count").show();
      $(".remaining").html(minus_price);
     // console.log("abcd");
    }
      if(tagprice == 0)
    {
      
      $(".tag-price-empty").show();
      
    }
      if(tagprice > firstprice)
    {
      $(".card-popup").show();
     $(".card-options").show();
     $(".tag-price-count").hide();
      
      //console.log("abcd");
     // console.log("Tagprice is"+tagprice);
     // console.log("Firstprice is"+firstprice);
    }
      
    });
    
   
    
      $(".product-info-box").hide();
      
      var priceadd = 0;
    $(".added-products .addproprice").each(function(){	
      var add_data_price = $(this).attr("data-price");
      console.log("data-price is:"+add_data_price);
    priceadd = parseFloat(priceadd) + parseFloat(add_data_price); 
      console.log("priceaddqwert=="+priceadd);
    })
    var tagprice = 0;
    $(".addtag").each(function(){
      var add_tag_total = $(this).attr("data-tag");
    tagprice = parseInt(tagprice) + parseInt(add_tag_total); 
      console.log("pricetag=="+tagprice);
    })
    
    
     var gettag = $(this).siblings(".tag").data("tag");
    var tagcount  = 0;
    $(".added-products .addtag").each(function(){
    var getcnt = $(this).attr("data-tag");
      tagcount = parseInt(tagcount)+parseInt(getcnt);
    })
    var remaining_count = parseInt(firstprice)-tagcount;
    console.log("remaining_count=="+remaining_count);
    
    $(".product-section .tag").each(function(){
     var getcnt123 = $(this).data("tag");
      if(getcnt123>remaining_count){
      $(this).parents(".product-section").addClass("oops");
      }
    })
    
    
     
var twoPlacedFloat = parseFloat(priceadd).toFixed(2);
    $(".subtotal-price").html(twoPlacedFloat);
    $(".checkout-button .subtotal").html(twoPlacedFloat);
    $(".product-info-box .variants").html(" ");
    $(".product-info-box .info-custom").html(" ");
   // $(".product-info-box .slider-box").removeClass("owl-loaded");
    $(".product-info-box .slider-box").html(" ");
    $('.owl-carousel').data('owlCarousel').destroy();
   if( $(".owl-item").length  < 2 )
   {
     $(".owl-controls").hide();
   }
    })
  
  
  
   $(".complete-button").click(function(){
     
     
     var tagprice = 0;
    $(".addtag").each(function(){
    tagprice = parseInt(tagprice) + parseInt($(this).data("tag")); 
     // console.log("pricetag=="+tagprice);
    })
    
     
    var tagprice_total = tagprice;
 console.log("tweret123"+tagprice_total);
   
      if(tagprice == 0)
    {
      
      $(".tag-price-empty").show();
      
    }
      
      
    });

    $(".card-options li").click(function(){
    
      $(".card-options").hide();
      $(".card-message").show(); 
    var src =  $(this).find('img').attr('src');
      $(".card-message .image-column").find('img').attr('src',src);
      console.log(src);
      
    })
    $(".card-message a").click(function(){
    
      $(".card-options").show();
      $(".card-message").hide();     
      
    })
    
   
   $(".complete-count").click(function() {
     console.log("card type is selected");
     console.log($('input[name=card-type]:checked', '.modal-card-options').val()); 
     $(".card-popup").show();
     $(".card-options").show();
     $(".tag-price-count").hide();
   })
   $(".complete-without-count").click(function() {
     $(".tag-price-empty").hide();
   })
   
   
   $(".card-add-button").click(function() {
    // alert();
     var card_option_val = $("input[name=card-type]:checked").val();
     var message = $('textarea#message').val();
     console.log("Card Option Value"+card_option_val);
     
     
    
     
     
     if (!$("input[name='card-type']:checked").val()) {
  // alert('Nothing is checked!');
       console.log("nothing is checked");
       $(".card-popup").hide();
       $(".no-message-card-popup").hide();
      $(".card-not-selected").show();
       
       
       
}
else {
  console.log("else condition for message");
   $(".card-options").hide();
  $(".card-popup").show();
  $('.card-message').show();
  $(".no-message-card-popup").hide();
 // alert('checked and value is:'+card_option_val);
  $(".card-add-button").addClass('after_button');
 console.log("else condition for message");
  
   console.log("Double clicked");
     var card_option_val = $("input[name=card-type]:checked").val();
     var message = $('textarea#message').val();
       console.log("Message is: "+message);
    if(message == '')
     {
     $('.no-message-card-popup').show();
        $(".card-popup").hide();
  $('.card-message').hide();
     }
          else {
            
            var title_post = $("input[name=card-type]:checked").val();
            var price_post = $(".subtotal-price").html();
            var message_post = $('textarea#message').val();
            var box_type_post = $("input[name=box-color]:checked").val();
            
            var desc = "";
     var des_product = $(".rightboxsecfirst").html();
     $(".added-products").each(function(){
     var quantity = $(this).children(".addproindex").html();
       var title = $(this).children(".addtitle").html();
      var variants = $(this).children(".variants_value").html();
       var attributes = $(this).children(".attribute_value").html();
       console.log("variants are:"+variants);
       console.log("attributes are:"+attributes);
       if(variants == null)
       {
         variants = " ";
       }
         if(attributes == null)
       {
         attributes = " ";
       }
         desc = desc+"<div class='line'>"+quantity+"x"+title+" "+variants+" "+attributes+"</div>";
     
       
     })
    
    
            
           if ($('input[name=card-outside]').is(':checked')) {
             var card_location = 'Outside';
            // var card_location_post = 'yes';
           }
            else
            {
              var card_location = 'Inside';
             // var card_location_post = 'no';
            }
            
            $('input:radio[name=card-type]').each(function () {
         console.log("All card Unchecked");
         $(this).prop('checked', false); 
       });
            $("#message").html(" ");
         // alert(message);
           
           $.ajax({            
             url: 'https://upbrighterservices.com/shopbox/addpro.php',
//       contentType: "application/json",
	 dataType: 'html',
      data: {
        title: title_post,               
        price: price_post,
        description: desc
      },       
      error: function(data) {
        alert("error"+data);
      },         
      success: function(data) {
       // alert("data is: ");
       // alert(data);
       // alert(data[0][id]);
        
       // console.log("data is: ");
        var var_id = data;
        console.log("Data is: "+var_id);
      /*  $("#results").html(data);
        data = data.toString();
        data = JSON.parse(data);*/
       //console.log(data[id]);
         $(".card-popup").hide();
        $(".box_adding").show();
        
         $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + 1 + "&id=" + var_id + "&properties[Box Color]=" + box_type_post + "&properties[Message on Card]=" + message + "&properties[Card Location]=" + card_location,
                dataType: "json",               
                success: function(n) {
                  
                  console.log(n);
                  $(".card-popup").hide();
        $(".box_adding").hide();
                  $(".box_added_popup").show();
                  
                },
           error: function(n) {
        alert("error"+n);
      }
         })
                  
                  
        
        
        
      },
      type: 'POST'
    });
            
            
            
          }
}
     
      
                                  
                              
                              
                              
    
     
   })
   
   $(".card-add-button.after_button").click(function() {
    
   })
   
    $(".select-card-button").click(function(){
     
  $('.card-popup').show();
       $('.card-not-selected').hide();
       
     })
   
   
   
   

     $(".write-message-button").click(function(){
       $(".card-popup").show();
       $(".card-options").show();
       $('.card-message').hide();
        $('.no-message-card-popup').hide();
       $('.card-not-selected').hide();
       $(".card-add-button").removeClass('after_button');      
       $('input:radio[name=card-type]').each(function () {
         console.log("All card Unchecked");
         $(this).prop('checked', false); 
       });
       var card_option_val = $("input[name=card-type]:checked").val();
       console.log("card option value after write message button"+card_option_val);
     })
     $(".leave-button").click(function(){
       console.log("ajax call");
       
        var title_post = $("input[name=card-type]:checked").val();
            var price_post = $(".subtotal-price").html();
            var message_post = $('textarea#message').val();
            var box_type_post = $("input[name=box-color]:checked").val();
            
            var desc = "";
     var des_product = $(".rightboxsecfirst").html();
     $(".added-products").each(function(){
     var quantity = $(this).children(".addproindex").html();
       var title = $(this).children(".addtitle").html();
     desc = desc+"<div class='line'>"+quantity+"x"+title+"</div>";
     })
    
    
            
           if ($('input[name=card-outside]').is(':checked')) {
             var card_location = 'Outside';
            // var card_location_post = 'yes';
           }
            else
            {
              var card_location = 'Inside';
             // var card_location_post = 'no';
            }
            
            $('input:radio[name=card-type]').each(function () {
         console.log("All card Unchecked");
         $(this).prop('checked', false); 
       });
            $("#message").html(" ");
         // alert(message);
           
           $.ajax({            
      url: 'http://uvandcode.com/shopbox/addpro.php',
//       contentType: "application/json",
	 dataType: 'html',
      data: {
        title: title_post,               
        price: price_post,
        description: desc
      },       
      error: function(data) {
        alert("error"+data);
      },         
      success: function(data) {
       // alert("data is: ");
       // alert(data);
       // alert(data[0][id]);
        
       // console.log("data is: ");
        var var_id = data;
        console.log("Data is: "+var_id);
      /*  $("#results").html(data);
        data = data.toString();
        data = JSON.parse(data);*/
       //console.log(data[id]);
         $(".card-popup").hide();
        $(".box_adding").show();
        
         $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + 1 + "&id=" + var_id + "&properties[Box Color]=" + box_type_post + "&properties[Message on Card]=" + message + "&properties[Card Location]=" + card_location,
                dataType: "json",               
                success: function(n) {
                  
                  console.log(n);
                  $(".card-popup").hide();
        $(".box_adding").hide();
                  $(".box_added_popup").show();
                  
                },
           error: function(n) {
        alert("error"+n);
      }
         })
                  
                  
        
        
        
      },
      type: 'POST'
    });
          
       
       
       
     })
    
  
    $(".product-section .imagee").click(function(){
      var info_title = $(this).siblings(".titlee").html();
  var info_description = $(this).siblings(".description").html();
      var info_src =  $(this).find("img").attr("src");
      var info_price = $(this).siblings(".price").html();
      var info_withoutprice = $(this).siblings(".price").data("price");
      var info_tag = $(this).siblings(".tag").data("tag");
      var info_handle = $(this).siblings(".handle").html();
      var info_custom = $(this).siblings(".custom-information").html();
      var info_slider = $(this).siblings(".product-slider-images").html();
       var info_selection= "";
      var option_hidden = $(this).siblings(".selector-wrapper").children('select[data-option=option1]').val();
      $(this).siblings(".selector-wrapper").each(function(){
      info_selection = $(this).html();
        console.log(info_selection);
        
        if(option_hidden == 'Default Title')
        {
        }
        else
        {
        $(".product-info-box .variants").append(info_selection);
        }
      })
      console.log("Info Custom:"+info_custom);
      
      if(info_custom == null)
        {
        }
        else
        {
        $(".product-info-box .info-custom").html(info_custom);
         $(".product-info-box .info-custom").show(); 
        }
      $(".product-info-box .slider-box").append(info_slider);
      $(".product-info-box").show();
      $(".product-info-box .info-title").html(info_title);
      $(".product-info-box .info-description").html(info_description);
      $(".product-info-box .info-image img").attr("src",info_src);
      $(".product-info-box .titlee").html(info_title);
      $(".product-info-box .image_info").attr("src",info_src);
      $(".product-info-box .info-tag").html(info_tag);
      $(".product-info-box .handle").html(info_handle);
      $(".product-info-box .price").html(info_price);
      $(".product-info-box .without_price").html(info_withoutprice);
          
     
      $(".owl-carousel").owlCarousel({
        items: 1,
        autoplay: true
      });
      
     
    })
    
    $('body').on('click', '.cross-product', function () {
      var handle_match = $(this).siblings(".addhandle").html();
      $(".leftboxsec .image-handle .gethandle").each(function( index ) {
  var left_handlematch = $(this).html();
        if(handle_match == left_handlematch)
        {
          console.log("image-handle matched");
          $(this).parents(".image-handle").remove();
        }
});
      
    $(this).parents(".added-products").remove();
      
      
       $(".image-box-lower .gethandle").each(function( index ) {
  var left_handlematch = $(this).html();
        if(handle_match == left_handlematch)
        {
          console.log("image-handle matched");
          $(this).parents(".image-box-lower").remove();
        }
});
      if($(".image-box-lower").length == 0)
      {
        $("#custom-box-tray").hide();
      }
      
      
       var priceadd = 0;
    $(".addproprice").each(function(){
    priceadd = parseInt(priceadd) + parseInt($(this).data("price")); 
      console.log("priceadd=="+priceadd);
    })
    var tagprice = 0;
    $(".addtag").each(function(){
    tagprice = parseInt(tagprice) + parseInt($(this).data("tag")); 
      console.log("pricetag=="+tagprice);
    })
    
    
    
    var tagcount  = 0;
    $(".added-products .addtag").each(function(){
    var getcnt = $(this).attr("data-tag");
      tagcount = parseInt(tagcount)+parseInt(getcnt);
    })
    var remaining_count = parseInt(firstprice)-tagcount;
    console.log("remaining_count=="+remaining_count);
    
    $(".product-section .tag").each(function(){
     var getcnt123 = $(this).data("tag");
      if(getcnt123>remaining_count){
      $(this).parents(".product-section").addClass("oops");
      }
      if(getcnt123<remaining_count){
      $(this).parents(".product-section").removeClass("oops");
      }
    })
    
    
    
    
     
    var twoPlacedFloat = parseFloat(priceadd).toFixed(2)
    $(".subtotal-price").html(twoPlacedFloat);
      $(".checkout-button .subtotal").html(twoPlacedFloat);
      
      
    })
    $(".cancel").click(function(){
      $(".tag-price-count").hide();
       $(".card-popup").hide();
      
      
      
    })
    
    $(".modal-close").click(function(){
      $(".tag-price-count").hide();
      $(".tag-price-empty").hide();
       $(".card-popup").hide();
      $(".card-message").hide();
     $(".product-info-box").hide();
      $(".card-not-selected").hide();
      $(".card-not-selected .no-message-card-popup").hide();
      $(".no-message-card-popup").hide();
      $(".card-add-button").removeClass('after_button');      
       $('input:radio[name=card-type]').each(function () {
         console.log("All card Unchecked");
         $(this).prop('checked', false); 
       });
      $(".box_adding").hide();
      $(".box_added_popup").hide();
      
       $(".product-info-box .variants").html(" ");
      $(".product-info-box .info-custom").html(" ");
     // $(".product-info-box .slider-box").removeClass("owl-loaded");
      $(".product-info-box .slider-box").html(" ");
     // $(".owl-carousel").removeClass('owl-loaded'); 
     //  $(".owl-carousel").owlCarousel('destroy');
      $('.owl-carousel').data('owlCarousel').destroy();
    })
    $(".image-column").click(function(){
    $(".card-message").hide();
      $(".card-options").show();
    })
     $(".keep-shipping").click(function(){
      $(".box_added_popup").hide();
    })
    $(".go-to-cart").click(function(){
      location.href = "/cart";
    })
   
    $(".checkout-button").click(function(){
      $(".complete-button").trigger("click");
    })
  
})








/* select call back 
<script src="//cdn.shopify.com/shopifycloud/shopify/assets/themes_support/option_selection-fe6b72c2bbdd3369ac0bfefe8648e3c889efca213baefd4cfb0dd9363563831f.js" type="text/javascript"></script>

  var selectCallback = function(variant, selector) {
    timber.productPage({
      money_format: "",
      variant: variant,
      selector: selector,
      translations: {
        add_to_cart : "Add to Cart",
        sold_out : "Sold Out",
        unavailable : "Unavailable"
      }
    });
  };

  jQuery(function($) {
    new Shopify.OptionSelectors('productSelect', {
      product: null,
      onVariantSelected: selectCallback,
      enableHistoryState: true
    });

    // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
    

    // Hide selectors if we only have 1 variant and its title contains 'Default'.
    
  });

*/


// ===============================
$(document).ready(function(){
$(".collection-tags > li").click(function(){
	var gettag = $(this).attr("data-tag");
  if(gettag == 'all-tags'){
  $(".product-section").show();
  }
  else{
  $(".product-section").each(function(){
  var chktag = $(this).attr("data-tags");
    
    if ( chktag.indexOf(gettag) !== -1 ) {
      $(this).show();
    }
    else{
      $(this).hide();
    }
    
  })
}
})

})















